import clsx from 'clsx'
import { IconSvg } from 'components/common'
import { ClubTier } from 'graphql/generated/scheme'
import { forwardRef } from 'react'

interface TierBadgeBackendProps {
	background?: string
	foreground?: string
	border?: string
	name?: string
	locked?: boolean
	showLock?: boolean
	tier?:
		| ClubTier
		| {
				// for multiple support
				name?: string
				colors?: {
					background?: string
					foreground?: string
					border?: string
				}
		  }
}

export const TierBadgeBackend = forwardRef<any, TierBadgeBackendProps>((props, ref) => {
	const { background, foreground, border, name, locked, showLock, tier } = props

	return (
		<div className="flex gap-1">
			{locked && showLock && <IconSvg icon="lock" />}
			<div
				style={{
					backgroundColor: tier?.colors?.background ?? background,
					color: tier?.colors?.foreground ?? foreground,
					borderColor: tier?.colors?.border ?? border,
				}}
				ref={ref as React.RefObject<HTMLDivElement>}
				{...props}
				className={clsx(
					'cursor-default rounded shadow border backdrop-blur-[6px] justify-center items-center gap-3 flex text-sm italic font-black uppercase leading-none tracking-wide w-[90px] h-[26px]'
				)}
			>
				{tier?.name ?? name}
			</div>
		</div>
	)
})
